import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const ServisSpravaPage = lazy(() =>
  import('@/modules/servis/ServisSpravaPage').then((m) => ({ default: m.ServisSpravaPage })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/sprava',
  component: () => (
    <Suspense fallback={null}>
      <ServisSpravaPage />
    </Suspense>
  ),
});
